import React from 'react'
import useEditRequirements from './use-edit-requirements'
import Requirement from './requirement'

const RequirementsEditor = ({
    requirements: courseRequirements = [],
    onRequirementsChange: onCourseRequirementsChange = () => {},
}) => {

    const {
        requirements,
        addRequirement,
        removeRequirement,
        setRequirementValue
    } = useEditRequirements({
        courseRequirements,
        onCourseRequirementsChange
    })

    const renderRequirement = (requirement) => (
        <Requirement
            key={requirement.id}
            requirement={requirement}
            checked={requirement.enabled}
            value={requirement.value}
            onCheckChanged={enabled => enabled ? addRequirement(requirement.id) : removeRequirement(requirement.id)}
            onValueChange={value => setRequirementValue(requirement.id, value)}
        />
    )

    return (
        <React.Fragment>
            {requirements.map(renderRequirement)}
        </React.Fragment>
    )
}

export default RequirementsEditor